import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from "../../components/button/button.component";

interface BeforeInstallPromptEvent extends Event {}

@Component({
  selector: 'app-install-pwa-prompt',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './install-pwa-prompt.component.html',
  styleUrl: './install-pwa-prompt.component.scss'
})
export class InstallPwaPromptComponent implements OnInit {
  canInstall = false;
  deferredPrompt: any;

  ngOnInit() {
    let _this = this;
    window.addEventListener('beforeinstallprompt', (event: Event) => {
      _this.canInstall = true;
      _this.deferredPrompt = event as BeforeInstallPromptEvent;
    });
  }

  installPwa() {
    if (this.deferredPrompt) {
      // Show the custom prompt
      this.deferredPrompt.prompt();

      // Wait for the user's response
      this.deferredPrompt.userChoice.then((choiceResult: { outcome: string }) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt.');
        } else {
          console.log('User dismissed the install prompt.');
        }
        this.deferredPrompt = null;
        this.canInstall = false;
      });
    } else {
      console.log('No deferred prompt to show.');
    }
  }
}
